import { useMutation } from "@tanstack/react-query";
import { useUserSettingsDispatchContext } from "core/user.settings/hooks";
import { PostLoginRequest } from "./api";

type Props = {
    onSuccess?: (data: any) => void;
    onError?: (error: any) => void;
}

const useLogin = (props?: Props) => {
    const setUserSetting = useUserSettingsDispatchContext();

    const {mutate, isLoading, isError, error} = useMutation(PostLoginRequest, {
        onSuccess: (response: any) => {
            setUserSetting('user', JSON.stringify({
                'role': response.data.role,
                'first_name': response.data.first_name,
                'last_name': response.data.last_name,
                'email': response.data.email,
                'agency_ids': response.data.agency_ids || [],
            }));
            props?.onSuccess && props.onSuccess(response);
        },
        onError: props?.onError,
    });

    return {mutate, isLoading, isError, error};
};

export { useLogin };
